import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import InstructorsTab from '../../components/InstructorsTab';
import ContentOutputTab from '../../components/ContentOutputTab';
import PreconditionsTab from '../../components/PreconditionsTab';

/**
 * Eğitim düzenleme sayfasının alt kısmı — "Eğitmenler", "İçerik / Kazanım" ve "Ön Koşullar"
 * sekmeleri. Eskiden `TrainingDetailDialog.jsx` içinde ayrı bir dialog'du (tablodaki İçerik/Kazanım
 * ikonuyla açılıyordu); artık ayrı bir giriş noktası yok, düzenleme sayfasının kendisinin bir parçası
 * (bkz. `TrainingCatalogCreateEdit.jsx` — claim düzenleme sayfasındaki gibi üstte form, altta detay
 * sekmeleri). Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 2.md §4-7.
 *
 * Katalog kaydı (id, instructorsCount) sayfa tarafından zaten `GetById` ile çekilip prop olarak
 * geçiliyor — burada ayrıca bir sorgu yapılmıyor.
 */
const TrainingCatalogDetailTabs = ({ trainingId, instructorsCount, readOnly = false }) => {
    const { th } = useLanguage();
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel
                header={
                    <span className="tab-header">
                        <i className="pi pi-users mr-2" />
                        {th('trainingCatalog.instructors.tabTitle')}
                        {Number(instructorsCount) > 0 && <span className="ml-2 px-2 py-1 border-round text-xs font-semibold bg-blue-100 text-blue-800">{instructorsCount}</span>}
                    </span>
                }
            >
                {trainingId && <InstructorsTab trainingId={trainingId} readOnly={readOnly} />}
            </TabPanel>
            <TabPanel
                header={
                    <span className="tab-header">
                        <i className="pi pi-book mr-2" />
                        {th('trainingCatalog.contentOutput.tabTitle')}
                    </span>
                }
            >
                {trainingId && <ContentOutputTab trainingId={trainingId} readOnly={readOnly} />}
            </TabPanel>
            <TabPanel
                header={
                    <span className="tab-header">
                        <i className="pi pi-shield mr-2" />
                        {th('trainingCatalog.preconditions.tabTitle')}
                    </span>
                }
            >
                {trainingId && <PreconditionsTab trainingId={trainingId} readOnly={readOnly} />}
            </TabPanel>
        </TabView>
    );
};

export default TrainingCatalogDetailTabs;
